import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { CollectionNoteModel } from "./models";

export type GetCollectionNotesRequest = {
  addressUnitNo: string;
  addressStreetNo: string;
  addressStreetName: string;
  addressSuburbName: string;
  addressStateCode: string;
  addressPostCode: string;
  addressCountry: string;
};

export type GetCollectionNotesResponse = {
  notes: CollectionNoteModel[];
};

export const getCollectionNotes = async (request: GetCollectionNotesRequest) => {
  const response = await executeApiRequest(
    () => axios.get<GetCollectionNotesResponse>(`/notes`, { params: request }),
    false
  );

  return response?.data.notes;
};
